import React from "react";
import Accordion from "../Accordion/Accordion";

const ConfirmEmail = (props) => {
  return (
    <Accordion
      tabName="Your details"
      accordionId="accordionEmail"
      // userAddresses={this.props.data.userAddresses}
      userAddresses={props.appProp.data.confirmAddressSummary}
      profileEmail={props.appProp.data.profileEmail}
      classes="email-tab"
      guestEmail={props.kkUserEmail || props.data.guestEmail}
      lastValidGuestEmail={props.data.lastValidGuestEmail}
      submitGuestEmail={props.submitGuestEmail}
      guestEmailHasValue={
        props.data.guestEmailHasValue +
        (props.data.addressErrors.guestEmail ? " error-field" : "")
      }
      guestEmailChangedHandler={props.guestEmailChangedHandler}
      guestEmailBlurHandler={props.guestEmailBlurHandler}
      guestEmailError={props.data.addressErrors.guestEmail}
      thisRef={props.accordionDetailsRef}
      signInLink={props.signInLink}
      signinAndCheckoutLink={props.signinAndCheckoutLink}
      confirmRedirect={props.confirmRedirect}
      guestEmailRef={props.guestEmailRef}
      onKeyPress={props.onKeyPress}
      customerIsGuest={props.customerIsGuest}
      isUserRegistered={props.isUserRegistered}
      isGuestRegisterSuccess={props.isGuestRegisterSuccess}
      customerIsLoggedIn={props.customerIsLoggedIn}
    />
  );
};

export default ConfirmEmail;
